module.exports = __webpack_public_path__ + "static/media/background_02.98aa7af7.jpg";